/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'react-autobind';
import { withRouter, Redirect } from 'react-router-dom';
import moment from 'moment';
import Dropzone from 'react-dropzone';

import Select from 'react-select';
import Switch from 'react-toggle-switch';
import DatePicker from "react-datepicker";
import { Container, Row, Col, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Header from '../../components/Header';
import SuperAdminHeader from '../../components/Header/SuperAdmin';
import Subheader from '../../components/Subheader';
import Footer from '../../components/Footer';
import Dialog from "../../components/Dialog/Dialog";
import StatisticsTiles from "../../components/Statistics/StatisticsTiles";
import Alert from "../../components/Errors/Alert"
import * as actions from "../../redux/actions"
import ErrorHelper from '../../components/ErrorHelper';
import QRModal from '../../components/Story/QRModal';
import { generateId, mapCategoriesToOptions } from '../../lib/utils';
import StorySection from './StorySection';

class UpdateStory extends Component {

  constructor(props) {
    super(props);
    autobind(this);
    this._isMounted = false;
    const { match } = this.props;

    // TODO: remove not use attributes if they are not needed anymore
    this.state = {
      // init: false,
      storyId: match.params.storyId,
      name: '',
      description: '',
      category: null,
      allCategories: [],
      categoryOptions: [],
      subCategoryOptions: [],
      acceptedImage: [],
      sectionImages: {},
      // rejectedImage: [],
      categories: [],
      products: [],
      // productsInStory: [],
      productsSideBarOpen: false,
      storage: '',
      traffic: '',
      endDate: moment(),
      // hoverStates: [],
      confirmDeleteModalOpen: false,
      toDeleteProductId: null,
      toDeleteCategoryId: null,
      toDeleteSectionId: null,
      adminApproved: false,
      price: 0,
      showConfirmPricingPopup: false,
      rejectPricingConfirmPopup: false,
      privateStory: false,
      storyAccessLink: false,
      dataCollection: false,
      validationFieldsTouched: {
        name: false,
        category: false,
        description: false,
        storage: false,
        traffic: false,
        endDate: false,
      }
    };

  }

  componentDidMount() {
    this._isMounted = true;

    const { getProducts, getStatisticsByStory, getStories, getCategories } = this.props;
    const { storyId } = this.state;

    getStories().catch((error) => {
      console.error("Loading stories failed", error);
    });
    getProducts();
    getStatisticsByStory(storyId);
    getCategories('FURNITURE', (allCategories) => {
      const { category, categories } = this.state;

      if (allCategories && category) {
        const categoryOptions = mapCategoriesToOptions(allCategories);
        const subCategoryOptions = mapCategoriesToOptions(allCategories.filter((c) => {
          if (c.parent === category._id) {
            return c;
          }
        }));

        subCategoryOptions.push({
          value: null,
          label: "None"
        })

        this.setState({
          allCategories,
          categoryOptions,
          subCategoryOptions
        })
      }
    });

  }

  componentWillReceiveProps(props) {
    const { story, products, impersonating } = props

    let newState = {}
    if (story) {
      newState = {
        init: true,
        name: story.name,
        description: story.description,
        authorName: story.authorName,
        category: story.category,
        storage: story.storage,
        traffic: story.traffic,
        endDate: moment(story.endDate),
        storyPath: story.storyPath,
        categories: story.categories,
        adminApproved: story.adminApproved,
        products,
        price: story.price,
        showConfirmPricingPopup: (!story.adminApproved && story.priceSet),
        impersonating,
        privateStory: story.privateStory,
        storyAccessLink: story.storyAccessLink,
        dataCollection: story.dataCollection
      }

    }
    this.setState(newState)

  }

  componentWillUnmount() {
    this._isMounted = false;
    const { clearErrors } = this.props;
    clearErrors();
  }

  componentDidUpdate(prevProps) {
    ErrorHelper.scrollOnError(this.props, prevProps, ['errorInProducts', 'errorInStories']); //TODO handle multiple namespaces
  }

  cancel() {
    const { history } = this.props;
    history.push("/stories");
  }

  updateStory() {
    const { updateStory, addErrors } = this.props;
    const { name, description, authorName, acceptedImage, categories, impersonating,
      storage, traffic, endDate, storyId, privateStory, storyAccessLink, dataCollection, sectionImages } = this.state;

    const validationErrors = this.validateStorySections();
    if(validationErrors.length) {
      addErrors(validationErrors);
      // still has errors, scroll to top
      window.scrollTo(0, 0);
      return;
    }

    const dataToUpload = {
      name,
      description,
      authorName,
      changeStoryPath: (acceptedImage.preview ? acceptedImage : null),
      categories,
      privateStory,
      storyAccessLink,
      dataCollection,
      sectionImages: Object.keys(sectionImages).length > 0 ? sectionImages : null
    }

    if (impersonating) {
      dataToUpload.storage = storage;
      dataToUpload.traffic = traffic;
      dataToUpload.endDate = endDate;

    }

    updateStory(dataToUpload, storyId)
      .then(() => this.resetValidationTouched())
      .catch((error) => {
        console.error(error);
      });
  }


  onDropStoryImage(acceptedFiles, rejectedFiles) {

    this.setState({
      acceptedImage: acceptedFiles[0],
      // rejectedImage: rejectedFiles
    });
  }

  dummy() {
    // dummy method required to escape invalid onClick warning
    // this is needed because onClick is mandatory on <Switch>, but the switch is disabled
  }

  renderProductImageUpload() {
    const { acceptedImage, storyPath } = this.state;
    if (acceptedImage.length > 0 || storyPath) {
      return (
        <div className="d-flex justify-content-center">
          <div className="product-upload__image-container">
            <div className="product-upload__image-edit">
              <Dropzone
                onDrop={(accepted, rejected) => {
                  this.onDropStoryImage(accepted, rejected)
                }}
                className="s7-upload"
              />
            </div>

            <img
              src={acceptedImage.preview ? acceptedImage.preview : storyPath}
              className="product-upload__image"
              alt="Story"
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="d-flex justify-content-center mb-2">
          <Dropzone
            onDrop={(accepted, rejected) => {
              this.onDropStoryImage(accepted, rejected)
            }}
            className="btn btn-rounded btn-space btn-secondary"
          >
            Upload Story Image
          </Dropzone>
        </div>
        <p className="text-center mb-1"><em>Recommended: 960x270px</em></p>
        <p className="text-center mb-0"><em>white background jpg</em></p>

      </div>
    );
  }

  updateAuthorName(e) {
    this.setState({
      authorName: e.target.value
    });
  }

  addCategory() {
    const { categories } = this.state;

    categories.push({
      _id: generateId(),
      category: null,
      sections: []
    });

    this.setState(state => (
      {
        categories
      }
    ));
    this.forceUpdate();

  }

  deleteCategory(categoryId) {

    let { categories, sectionImages } = this.state;

    // delete section images added (if any)
    const category = categories.find(cat => cat._id === categoryId);
    const categorySectionsId = category.sections.map(section => section._id);
    categorySectionsId.forEach(sectionId => {
      delete sectionImages[sectionId];
    })

    // filter out category
    categories = categories.filter(obj => obj._id !== categoryId);

    this.setState(state => (
      {
        categories,
        sectionImages
      }
    ), () => console.log(this.state.sectionImages));
    this.forceUpdate();
  }


  updateCategory(categoryId, referenceCategoryId) {

    const { categories } = this.state;

    categories.map((category) => {
      if (category._id === categoryId) {
        category.category = referenceCategoryId.value;
      }

    }, {});

    this.setState(state => (
      {
        categories
      }
    ));
    this.forceUpdate();
  }

  updateCategoryLinking(categoryId, e) {
    const { categories } = this.state;

    categories.map((category) => {
      if (category._id === categoryId) {
        category.linkedProducts = !category.linkedProducts;
      }
    }, {});

    this.setState(state => (
      {
        categories
      }
    ));
    this.forceUpdate()
  }

  addNewSection(categoryId) {
    const { categories } = this.state;

    categories.map((category) => {
      if (category._id === categoryId) {
        category.sections.push({
          _id: generateId(),
          name: "",
          description: "",
          products: []
        })
      }
    }, {})

    this.setState({
      categories
    });

    this.forceUpdate();
  }

  updateSectionField(categoryId, sectionId, value, field) {
    const { categories } = this.state;

    categories.map((category) => {
      if (category._id === categoryId) {
        category.sections.map((section) => {
          if (section._id === sectionId) {
            section[field] = value;
          }
        }, {})
      }
    }, {})

    this.setState(state => (
      {
        categories
      }
    ));
    this.forceUpdate();
  }

  deleteSection(categoryId, sectionId) {

    const { categories, sectionImages } = this.state;

    // remove section image from images
    delete sectionImages[sectionId];

    // remove section from categories
    categories.map((category) => {
      if (category._id === categoryId) {
        category.sections = category.sections.filter(obj => obj._id !== sectionId);
      }
    }, {})

    this.setState(state => (
      {
        categories,
        sectionImages
      }
    ));
    this.forceUpdate();
  }

  addSectionImage = (sectionId, callback) => (accepted, rejected) => {
    if (accepted[0]) {
      this.setState(state => {
        state.sectionImages[sectionId] = accepted[0];
        callback();
      });
      this.forceUpdate();
    }
  }

  clearSectionImage = (sectionId) => {
    const { sectionImages } = this.state;

    if (sectionImages[sectionId]) {
      delete sectionImages[sectionId];
      this.setState({
        sectionImages
      });
    }
  }

  onDragStart = (ev, id) => {
    ev.dataTransfer.setData("id", id);
  }

  onDropProduct = (ev, categoryId, sectionId) => {
    const productId = ev.dataTransfer.getData("id");
    const { categories } = this.state;

    if(!productId) return;

    categories.map((category) => {
      if (category._id === categoryId) {
        category.sections.map((section) => {
          if (section._id === sectionId) {
            if (section.products.indexOf(productId) === -1) {
              section.products.push(productId);
            }
          }
        }, {})
      }
    }, {});

    this.setState(state => (
      {
        categories
      }
    ));
    this.forceUpdate();
  }

  toggleProductsSidebar() {
    this.setState(prevState => ({
      productsSideBarOpen: !prevState.productsSideBarOpen
    }));
  }

  removeProduct = (categoryId, sectionId, productId) => {

    const { categories } = this.state;

    categories.map((category) => {
      if (category._id === categoryId) {
        category.sections.map((section) => {
          if (section._id === sectionId) {

            section.products = section.products.filter((product) => {
              if (product._id !== productId && product !== productId) {
                return product;
              }
            });
          }
        }, {})
      }
    }, {});

    this.setState(state => (
      {
        categories
      }
    ));
    this.forceUpdate();
  }

  confirmDeleteModalShow(categoryId, sectionId, productId) {
    this.setState({
      toDeleteProductId: productId,
      toDeleteCategoryId: categoryId,
      toDeleteSectionId: sectionId,
      confirmDeleteModalOpen: true
    })
  }

  confirmDeleteModalProceed() {
    const { toDeleteCategoryId, toDeleteSectionId, toDeleteProductId } = this.state;
    if (toDeleteCategoryId && toDeleteSectionId && toDeleteProductId) {
      // delete product

      this.removeProduct(toDeleteCategoryId, toDeleteSectionId, toDeleteProductId);
      this.confirmDeleteModalHide();

      return;
    }
    if (toDeleteCategoryId && toDeleteSectionId) {
      // delete section
      this.deleteSection(toDeleteCategoryId, toDeleteSectionId);
      this.confirmDeleteModalHide();

      return;
    }

    if (toDeleteCategoryId) {
      // delete category
      this.deleteCategory(toDeleteCategoryId);
      this.confirmDeleteModalHide();

    }
  }

  confirmDeleteModalHide() {
    this.setState({
      confirmDeleteModalOpen: false
    })
  }

  confirmRejectPricingConfirmPopupOpen() {
    this.setState({
      rejectPricingConfirmPopup: true
    })
  }

  confirmRejectPricingConfirmPopup() {
    const { deleteStory, history } = this.props;
    const { storyId } = this.state;

    deleteStory(storyId);
    this.confirmRejectPricingConfirmPopupHide();
    history.push("/stories");
  }

  confirmRejectPricingConfirmPopupHide() {
    this.setState({
      rejectPricingConfirmPopup: false
    });
  }

  confirmAgreePricing() {
    const { updateStory } = this.props;
    const { storyId } = this.state;
    const dataToUpload = {
      adminApproved: true
    }

    updateStory(dataToUpload, storyId);

    this.setState({
      adminApproved: true
    });

    // reload page
    this.togglePricingModalOpen();

    this.forceUpdate();
  }


  togglePricingModalOpen() {
    this.setState(prevState => ({
      showConfirmPricingPopup: !prevState.showConfirmPricingPopup
    }));
  }

  togglePrivateStory = () => {
    this.setState(prevState => {
      return {
        privateStory: !prevState.privateStory
      };
    });
  };

  toggleStoryAccessLink = () => {
    this.setState(prevState => {
      return {
        storyAccessLink: !prevState.storyAccessLink
      };
    });
  };

  toggleDataCollection = () => {
    this.setState(prevState => {
      return {
        dataCollection: !prevState.dataCollection
      };
    });
  };

  updateField(field, value) {
    this.setState((prevState) => ({
      [field]: value,
      validationFieldsTouched: Object.assign(prevState.validationFieldsTouched, { [field]: true })
    }));
  }

  resetValidationTouched = () => {
    this.setState({
      validationFieldsTouched: {
        name: false,
        category: false,
        description: false,
        storage: false,
        traffic: false,
        endDate: false,
      }
    })
  }

  validateStorySections = () => {
    const { categories, sectionImages } = this.state;

    const errors = [];
    errors.errorKeys = {};

    categories.forEach((category, catIdx) => {
      category.sections.forEach((section, secIdx) => {
        // validate if name and description present, then image should also be present.
        if(section.name && section.description && (sectionImages[section._id] || section.sectionURI) ) {
          // section valid
          return;
        }

        // if it has some of the attributes, check all individual atributes
        if(section.name || section.description || sectionImages[section._id] || section.sectionURI) {
          if(!section.name) {
            buildSectionErrorMessage("name", secIdx, catIdx, section._id, errors);
          }

          if(!section.description) {
            buildSectionErrorMessage("description", secIdx, catIdx, section._id, errors);
          }

          if(!(sectionImages[section._id] || section.sectionURI)) {
            buildSectionErrorMessage("image", secIdx, catIdx, section._id, errors);
          }
        }

      });
    });


    function buildSectionErrorMessage(field, sectionIndex, categoryIndex, sectionId, errorArray) {
      const message = `Section ${field} is required in Category ${categoryIndex + 1} -> Section ${sectionIndex + 1}. `;

      errorArray.push(message);

      if(!errorArray.errorKeys[sectionId]) {
        errorArray.errorKeys[sectionId] = {};
      }

      errorArray.errorKeys[sectionId] = Object.assign(errorArray.errorKeys[sectionId], { [field]: message });
    }

    return errors;
  }

  render() {
    const {
      user, impersonating, errorInStories,
      statistics, errorInProducts, requestingStories, clearErrorField
    } = this.props;
    const {
      name, description, authorName, category, categoryOptions,
      storage, traffic, endDate, adminApproved, productsSideBarOpen,
      subCategoryOptions, showConfirmPricingPopup, price,
      confirmDeleteModalOpen, rejectPricingConfirmPopup,
      storyAccessLink, validationFieldsTouched, sectionImages
    } = this.state;

    if (!user) {
      return <Redirect to="/login" />
    }

    if (user.role === 3) {
      return <Redirect to="/s/dashboard" />
    }


    const { categories, products } = this.state;

    const renderedImageUpload = this.renderProductImageUpload();
    const userIsSuperAdmin = user && user.role === 3;

    // TODO: to see in which scenarios this should happen
    // if (deleted) {
    //   return <Redirect to="/stories" />
    // }
    return (

      <div className={`${userIsSuperAdmin ? "superadmin" : ""} stories update`}>
        {userIsSuperAdmin ? <SuperAdminHeader /> : <Header />}
        <Subheader breadcrumbs={[{
          title: "Stories", link: "/stories"
        }, "Update Story"]}
        />

        <div className="stastistics-subheader">
          <div className="container mb-5">
            <StatisticsTiles statistics={statistics} />
          </div>
          <Container className="pb-5">
            {errorInStories ? <Alert message={errorInStories} /> : null}
            {errorInProducts ? <Alert message={errorInProducts} /> : null}
            <Row className="xs-gutters">
              <Col xs="5">
                <div className="pb-1 height-100">
                  <div className="panel panel-default mb-0 height-100">
                    <div className="panel-body panel-body--md upload-product-image-box d-flex align-items-center justify-content-center" >
                      {renderedImageUpload}
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs="7">
                <div className="panel panel-default mb-1">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <Col xs="6">
                        <div className="form-group row no-gutters">
                          <label
                            htmlFor="inputElement"
                            className="col-3 col-form-label pr-1"
                          >
                            Name*
                            </label>
                          <div className="col-9 pt-1">
                            <input
                              type="text"
                              placeholder="Enter name"
                              className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("name", errorInStories, validationFieldsTouched.name)}`}
                              value={name}
                              onChange={e => this.updateField("name", e.target.value)}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs="6">
                        <div className="form-group row no-gutters">
                          <label
                            htmlFor="inputElement"
                            className="col-3 col-form-label pr-1"
                          >
                            Collection
                            </label>
                          <div className="col-9">
                            <Select
                              name="product-category"
                              className="advanced-select"
                              value={category !== null && {
                                label: category.name,
                                value: category.value
                              }}
                              disabled
                              options={categoryOptions}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="panel panel-default mb-1">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <Col>
                        <div className="form-group row no-gutters">
                          <label
                            htmlFor="inputElement"
                            className="col-3 col-form-label pr-1"
                          >
                            Description*
                            </label>
                          <div className="col-9 pt-1">
                            <textarea
                              className={`form-control ${ErrorHelper.getValidationErrorClass("description", errorInStories, validationFieldsTouched.description)}`}
                              rows="5"
                              placeholder="No more than 1000 characters"
                              maxLength="1000"
                              value={description}
                              onChange={e => this.updateField("description", e.target.value)}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="form-group row no-gutters">
                          <label
                            htmlFor="inputElement"
                            className="col-3 col-form-label pr-1"
                          >
                            Author Name
                            </label>
                          <div className="col-9 pt-1">
                            <input
                              type="text"
                              placeholder={user.username}
                              className="form-control form-control-xs"
                              value={authorName}
                              onChange={this.updateAuthorName}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="xs-gutters">
              <div className="col-12">
                <div className="panel panel-default mb-1">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label
                            htmlFor="startsOn"
                            className="col-3 col-form-label pr-1"
                          >
                            Storage*
                            </label>
                          <div className="col-9 pt-1">
                            <input
                              type="text"
                              placeholder="Storage in MB"
                              className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("storage", errorInStories, validationFieldsTouched.storage)}`}
                              value={storage}
                              onChange={e => this.updateField("storage", e.target.value)}
                              disabled={!impersonating}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label
                            htmlFor="startsOn"
                            className="col-3 col-form-label pr-1"
                          >
                            Traffic*
                            </label>
                          <div className="col-9 pt-1">
                            <input
                              type="text"
                              placeholder="Traffic in MB"
                              className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("traffic", errorInStories, validationFieldsTouched.traffic)}`}
                              value={traffic}
                              onChange={e => this.updateField("traffic", e.target.value)}
                              disabled={!impersonating}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="endDate" className="col-3 col-form-label pr-1">
                            End date*
                            </label>
                          <div className="col-9 pt-1">
                            <DatePicker
                              dateFormat="DD/MM/YYYY"
                              selected={endDate}
                              onChange={newDate => this.updateField("endDate", newDate)}
                              className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClass("endDate", errorInStories, validationFieldsTouched.endDate)}`}
                              disabled={!impersonating}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Row>
            <Row className="xs-gutters">
              <div className="col-12">
                <div className="panel panel-default mb-1">
                  <div className="panel-body panel-body--md">
                    <Row>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="privateStory" className="col-6 col-form-label">Private Story Status:</label>
                          <div className="col-2 d-flex align-items-center">
                            <Switch id="privateStory" onClick={this.togglePrivateStory}
                              on={this.state.privateStory} className="switch-button switch-button-xs"
                              enabled={impersonating}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="storyAccessLink" className="col-6 col-form-label">Story Access Link:</label>
                          <div className="col-2 d-flex align-items-center">
                            <Switch id="storyAccessLink" onClick={this.toggleStoryAccessLink}
                              on={this.state.storyAccessLink} className="switch-button switch-button-xs"
                              enabled={impersonating}
                            />
                          </div>
                          {storyAccessLink &&
                            <QRModal user={user} storyId={this.state.storyId} />
                          }
                        </div>
                      </Col>
                      <Col xs="4">
                        <div className="form-group row no-gutters">
                          <label htmlFor="dataCollection" className="col-6 col-form-label">Data Collection:</label>
                          <div className="col-2 d-flex align-items-center">
                            <Switch id="dataCollection" onClick={this.toggleDataCollection}
                              on={this.state.dataCollection} className="switch-button switch-button-xs"
                              enabled={impersonating}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Row>
          </Container>
        </div>

        {adminApproved
          ? (
            <Container>
              <h2 className="mt-5 mb-5">Story content</h2>
              {categories.map(cat => (
                <div key={cat._id}>

                  <Row className="xs-gutters mt-2">
                    <div className="col-12 panel panel-default mb-1">
                      <div className="panel-body panel-body--md">
                        <Row>
                          <div className="col-8">
                            <div className="form-group row no-gutters">
                              <label
                                htmlFor="inputElement"
                                className="col-2 col-form-label pr-1"
                              >
                                Category
                                </label>
                              <div className="col-5 pt-1">
                                <Select
                                  name="product-category"
                                  className="advanced-select"
                                  value={cat.category}
                                  options={subCategoryOptions}
                                  onChange={e => this.updateCategory(cat._id, e)}
                                  removeSelected={true}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group row mb-0 col-12 no-gutters">
                              <label htmlFor="inputElement" className="col-7 col-form-label">Enable linking</label>
                              <div className="col-5 d-flex align-items-center">
                                <Switch onClick={e => this.updateCategoryLinking(cat._id, e)} on={!!cat.linkedProducts} className="switch-button switch-button-xs" />
                              </div>
                            </div>
                          </div>
                          <div className="col-1 text-right">
                            <span
                              className="ar-icon s7-trash"
                              onClick={() => {
                                this.confirmDeleteModalShow(cat._id, null, null)
                              }}
                            />
                          </div>
                        </Row>

                        {cat.sections.map(section => (
                          <StorySection
                            key={section._id}
                            section={section}
                            categoryId={cat._id}
                            addSectionImage={this.addSectionImage}
                            sectionImage={sectionImages[section._id] ? sectionImages[section._id] : {}}
                            updateSectionField={this.updateSectionField}
                            onDropProduct={this.onDropProduct}
                            confirmDeleteModalShow={this.confirmDeleteModalShow}
                            productsSideBarOpen={productsSideBarOpen}
                            toggleProductsSidebar={this.toggleProductsSidebar}
                            products={products}
                            removeProduct={this.removeProduct}
                            clearSectionImage={this.clearSectionImage}
                            errorInStories={errorInStories}
                            clearErrorField={clearErrorField}
                          />
                        ))}

                        <Row>
                          <div className="col-12">
                            <button
                              className="btn btn-space btn-primary rounded  mt-3"
                              onClick={() => {
                                this.addNewSection(cat._id)
                              }}
                            >
                              <i
                                className="icon icon-left s7-plus"
                              />
                              {' '}
                              Add new section
                              </button>
                          </div>
                        </Row>
                      </div>
                    </div>
                  </Row>
                </div>
              ))}

              <Row className="xs-gutters">
                <button
                  className="btn btn-space btn-primary mt-3 rounded"
                  onClick={() => {
                    this.addCategory()
                  }}>
                  <i
                    className="icon icon-left s7-plus "
                  />
                  {' '}
                  Add new category
                  </button>
              </Row>
              {productsSideBarOpen
                ? (
                  <div className="sidebar-right">
                    <Container className="fixed-header">
                      <Row className="xs-gutters">
                        <div className="col-10 pt-2">
                          <h2>Product list</h2>
                        </div>
                        <div className="col-2 text-left">
                          <span onClick={this.toggleProductsSidebar}>
                            <i className="icon s7-close display-4" />
                          </span>
                        </div>
                      </Row>
                    </Container>
                    <Container className="scroll-products mt-5">
                      <Row>
                        <div className="col-12">
                          {products.map(product => (
                            <div key={product._id} onDragStart={e => this.onDragStart(e, product._id)} draggable className="draggable story-product mb-1">
                              <div className="product-image-wrapper">
                                <img src={product.productPath} className="product-image-in-story" alt="Product" />
                              </div>
                              <div className="p-2">
                                {product.name}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Row>
                    </Container>
                  </div>
                )
                : ''}
            </Container>
          )
          : (
            <Container>
              <Row>
                <div className="col-12 text-center p-6">
                  You will be able to configure your story once IndexAR approves your request.
                  </div>
              </Row>

            </Container>
          )
        }

        <div className="fixed-bottom mb-3">
          <Container>

            <Row className="xs-gutters mt-2">
              <Col xs="8 btn-semi-dark" />
              <Col xs="2">
                <button
                  className="btn btn-semi-dark btn-block btn-lg upload-product__control-panel-item text-uppercase"
                  onClick={this.cancel}
                >
                  Back
                  </button>
              </Col>
              <Col xs="2">
                <button
                  className="btn btn-primary btn-lg btn-block upload-product__control-panel-item text-uppercase"
                  disabled={requestingStories}
                  onClick={this.updateStory}
                >
                  {requestingStories ? 'Saving...' : 'Save'}
                </button>
              </Col>
            </Row>

          </Container>
        </div>
        <Modal isOpen={showConfirmPricingPopup} toggle={this.togglePricingModalOpen} className={`modal-s ${userIsSuperAdmin ? "superadmin" : ""}`}>
          <ModalHeader>
            <span onClick={this.togglePricingModalOpen} className="s7-close modal-close" />
          </ModalHeader>
          <ModalBody className="pt-0">
            <div className="row xs-gutters">
              <div className="col-12 text-center">
                <h3>Your customised Quotation</h3>
              </div>
              <div className="col-12 pt-3">
                <div className="form-group row no-gutters">
                  <label
                    htmlFor="startsOn"
                    className="col-4 col-form-label pr-1"
                  >
                    Story Name
                      {' '}

                  </label>
                  <div className="col-8 pt-1">
                    <input
                      type="disabled"
                      placeholder="Story name"
                      className="form-control form-control-xs"
                      value={name}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group row no-gutters">
                  <label
                    htmlFor="startsOn"
                    className="col-4 col-form-label pr-1"
                  >
                    End Date
                      {' '}

                  </label>
                  <div className="col-8 pt-1">
                    <input
                      type="disabled"
                      placeholder="Story name"
                      className="form-control form-control-xs"
                      value={endDate && endDate.format("DD/MM/YYYY")}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group row no-gutters">
                  <label
                    htmlFor="startsOn"
                    className="col-4 col-form-label pr-1"
                  >
                    Storage (MB)
                    </label>
                  <div className="col-8 pt-1">
                    <input
                      type="disabled"
                      placeholder="Storage in MB"
                      className="form-control form-control-xs"
                      value={storage}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group row no-gutters">
                  <label
                    htmlFor="startsOn"
                    className="col-4 col-form-label pr-1"
                  >
                    Traffic (MB)
                    </label>
                  <div className="col-8 pt-1">
                    <input
                      type="disabled"
                      placeholder="Traffic in MB"
                      className="form-control form-control-xs"
                      value={traffic}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group row no-gutters">
                  <label
                    htmlFor="startsOn"
                    className="col-4 col-form-label pr-1"
                  >
                    Price
                    </label>
                  <div className="col-8 pt-1">
                    <input
                      type="disabled"
                      placeholder="Price"
                      className="form-control form-control-xs"
                      value={price}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group row no-gutters">
                  <label htmlFor="privateStory" className="col-4 col-form-label">Private Story Status</label>
                  <div className="col-2 d-flex align-items-center">
                    <Switch id="privateStory" onClick={this.dummy}
                      on={this.state.privateStory} className="switch-button switch-button-xs"
                      enabled={false}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group row no-gutters">
                  <label htmlFor="storyAccessLink" className="col-4 col-form-label">Story Access Link</label>
                  <div className="col-2 d-flex align-items-center">
                    <Switch id="storyAccessLink" onClick={this.dummy}
                      on={this.state.storyAccessLink} className="switch-button switch-button-xs"
                      enabled={false}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group row no-gutters">
                  <label htmlFor="dataCollection" className="col-4 col-form-label">Data Collection</label>
                  <div className="col-2 d-flex align-items-center">
                    <Switch id="dataCollection" onClick={this.dummy}
                      on={this.state.dataCollection} className="switch-button switch-button-xs"
                      enabled={false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row xs-gutters pt-3">
              <div className="col-12 text-right">
                <button className="btn btn-space btn-semi-dark text-uppercase" onClick={this.confirmRejectPricingConfirmPopupOpen}>Reject</button>
                <button className="btn btn-space btn-primary text-uppercase" onClick={this.confirmAgreePricing}>Agree</button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Footer />
        <Dialog open={confirmDeleteModalOpen} proceed={this.confirmDeleteModalProceed} cancel={this.confirmDeleteModalHide} message="Changes will only take effect after you save." />
        <Dialog open={rejectPricingConfirmPopup} proceed={this.confirmRejectPricingConfirmPopup} cancel={this.confirmRejectPricingConfirmPopupHide} message="Your story request will be deleted." />
      </div>

    );
  }

}

UpdateStory.propTypes = {
  allStories: PropTypes.array.isRequired,
  getStories: PropTypes.func.isRequired,
  user: PropTypes.object,
  impersonating: PropTypes.bool.isRequired,
  errorInStories: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  statistics: PropTypes.array,
  getProducts: PropTypes.func.isRequired,
  getStatisticsByStory: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  deleteStory: PropTypes.func.isRequired,
  updateStory: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  story: PropTypes.object,
  products: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  errorInProducts: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  clearErrors: PropTypes.func.isRequired,
}

UpdateStory.defaultProps = {
  user: null,
  errorInStories: null,
  errorInProducts: null,
  statistics: null,
  story: null
}

function getCourseById(stories, id) {
  return stories.find(story => story._id === id) || null;
}

function mapStateToProps(state, ownProps) {
  const {
    stories: {
      allStories, requestingStories, completedStories,
      errorInStories, statistics, clearErrors, addErrors, clearErrorField
    },
    products: { completed, all, error },
    getCategories: { categories },
    auth: { user, impersonating }
  } = state;
  const id = ownProps.match.params.storyId;
  const story = id ? getCourseById(allStories, id) : null;

  return {
    story,
    allStories,
    products: all,
    completed,
    errorInProducts: error,
    requestingStories,
    completedStories,
    categories,
    errorInStories,
    user,
    statistics,
    impersonating,
    clearErrors,
    addErrors,
    clearErrorField
  }
}

export default connect(
  mapStateToProps,
  actions,
  (stateProps, dispatchProps) => Object.assign({}, stateProps, dispatchProps)
)(withRouter(UpdateStory))

//TODO: add category disabled condition DNI;
{/* disabled={subCategoryOptions.length === 1 ? categories.length === subCategoryOptions.length : categories.length === subCategoryOptions.length} */ }


// WEBPACK FOOTER //
// ./src/containers/Stories/UpdateStory.js